import { MathJaxObject } from "mathjax-full/js/components/startup";
import { ItemId } from "../../../model/datasource";
import { ContentItem } from "../../../model/datasource/item";
import { AnswerType } from "../../../lib/userdata";

export abstract class DisplayItemFrontend<I extends ItemId> {
	abstract displayItemContent(content: ContentItem<I>, bindTarget: EventTarget): void

	abstract displayItemSelectedAnswer(content: ContentItem<I>, bindTarget: EventTarget, answer: AnswerType | undefined): void

	abstract displayItemReview(content: ContentItem<I>, answer: AnswerType | undefined): void

	abstract displayItemRendered(content: ContentItem<I>, mathjax: MathJaxObject): void

	abstract displayItemAlerts(content: ContentItem<I>): void

	hideItemTypes(): void {
		[
			document.querySelector('.item .unknown'),
			document.querySelector('.item .multiplechoice'),
			document.querySelector('.item .multiplecorrect'),
			document.querySelector('.item .numeric'),
			document.querySelector('.item .cloze'),
			document.querySelector('.item .matching'),
			document.querySelector('.item .sorting'),
			document.querySelector('.item .constructedresponse'),
			document.querySelector('.item .flashcard'),
		].filter(i => i).forEach(element => {
			element.classList.add('d-none');
		});
	}
}

export class UnknownFrontend<I extends ItemId> extends DisplayItemFrontend<I> {
	displayItemContent(content: ContentItem<I>, bindTarget: EventTarget): void {
		const unknown = document.querySelector('.item .unknown');
		unknown.classList.remove('d-none');
	}

	displayItemSelectedAnswer(content: ContentItem<I>, bindTarget: EventTarget, answer: AnswerType): void {
		// Do nothing.
		return;
	}

	displayItemReview(content: ContentItem<I>, answer: AnswerType | undefined): void {
		// Do nothing.
		return;
	}

	displayItemRendered(content: ContentItem<I>, mathjax: MathJaxObject): void {
		// Do nothing.
		return;
	}

	displayItemAlerts(content: ContentItem<I>): void {
		// Do nothing.
		return;
	}
}